import { AxiosError } from 'axios';
import { PaginatedData } from 'web-library/models/List';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_PROFILE_AMENDMENT_REQUESTS_LISTING_URL } from '../../constants/apiUrls';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { ProfileAmendmentRequestStatus } from './usePutCancelProfileAmendmentRequest';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ProfileAmendmentRequestsListingContent {
  requestDateTime: string;
  requestorName: string;
  requestorNricPassport: string;
  status: ProfileAmendmentRequestStatus;
  updatedAt: string;
  updatedBy: string;
  uuid: string;
}

export interface ProfileAmendmentRequestsListingRequest extends ApiPathParam {
  status: ProfileAmendmentRequestStatus | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: PaginatedData<ProfileAmendmentRequestsListingContent>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostProfileAmendmentRequestsListing = ({ onSuccess, onError }: Input = {}) => {
  const postProfileAmendmentRequestsListing = async (
    reqBody: ProfileAmendmentRequestsListingRequest
  ) => {
    const res = await axiosClient.post<PaginatedData<ProfileAmendmentRequestsListingContent>>(
      POST_PROFILE_AMENDMENT_REQUESTS_LISTING_URL({
        page: reqBody.page,
        order: reqBody.order as 'asc' | 'desc',
        sort: reqBody.sort,
        pageSize: reqBody.pageSize,
      }),
      {
        status: reqBody.status,
      }
    );
    return res.data;
  };

  return useCustomMutation(postProfileAmendmentRequestsListing, {
    onSuccess,
    onError,
  });
};
